import EnvHelper from '../helpers/envHelper';
import { get, post, post2 } from '../utilities/http';

const envHelper = EnvHelper.getInstance();

export const loginApi = async (data) => {
  return post(`${envHelper.getApiUrl()}/v2/oauth/token`, data);
};

export const accountTradeApi = async () => {
  return get(`${envHelper.getApiUrl()}/v2/user/account`);
};

export const serverApi = async () => {
  return get(`${envHelper.getApiUrl()}/v2/trade/server`);
};

export const firebaseCustomApi = async () => {
  return get(`${envHelper.getApiUrl()}/v2/firebase/token/custom`);
};

export const getMe = async () => {
  return get(`${envHelper.getApiUrl()}/v2/me`);
};

export const createOtpApi = async () => {
  return post(`${envHelper.getApiUrl()}/v2/user/otp`);
};

export const verifyOtpApi = async (body) => {
  return post(`${envHelper.getApiUrl()}/v2/user/otp/verify`, body);
};

export const depositDemoApi = async (body) => {
  return post2(`${envHelper.getApiUrl()}/v2/user/account/deposit/demo`, body);
};


export const getEddApi = async () => {
  return get(`${envHelper.getApiUrl()}/v2/edd`);
};
